<a *ngIf="recipeEventSummary" class="summary-link" [routerLink]="['/admin/recipe-event-summary', recipeEventSummary.artifactId]">
  <mat-card class="contrast card-link" [class.banner-error]="recipeEventSummary?.disabled" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
    <mat-card-content fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="space-between stretch" fxLayoutGap="15px" fxLayoutGap.lt-md="5px">
      <div class="drop-placeholder" *cdkDragPlaceholder></div>
      <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayout.lt-md="column" fxLayoutGap="15px" fxLayoutGap.lt-md="5px">
        <div fxLayoutGap="5px">
          <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"
            [matTooltip]="'key: ' + recipeEventSummary?.artifactKey"
            [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }"
            [innerHtml]="productName[recipeEventSummary?.productName] | encodeHtml | highlight: searchTerm">
          </strong>
        </div>
        
        <div *ngIf="showRenderer && recipeEventSummary?.rendererName">
          <span class="text-small text-success" [ngClass.lt-sm]="{'card-title': true}">{{ recipeEventSummary.rendererName }}</span>
        </div>
        
        <div *ngIf="recipeEventSummary?.warpEnvironment">
          <span class="text-small text-info" [ngClass.lt-sm]="{'card-title': true}">{{ environmentName[recipeEventSummary?.warpEnvironment] }}</span>
        </div>
  
        <div *ngIf="recipeEventSummary?.companyCode">
          <span class="text-small" [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="recipeEventSummary?.companyCode | encodeHtml | highlight: searchTerm"></span>
        </div>
  
        <div *ngIf="recipeEventSummary?.home" fxLayoutGap="5px">
          <span class="text-small">home</span>
          <span class="text-small" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="'home: ' + recipeEventSummary?.home" [innerHtml]="recipeEventSummary?.home | encodeHtml | highlight: searchTerm"></span>
        </div>
  
        <div *ngIf="!recipeEventSummary?.home" fxLayoutGap="5px">
          <span class="text-small">key</span>
          <span class="text-small" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="'key: ' + recipeEventSummary?.artifactKey" [innerHtml]="((recipeEventSummary?.artifactKey | replace:'\\\\':' ') | replace:'/':' ') | encodeHtml | highlight: searchTerm"></span>
        </div>
        
        <div *ngIf="recipeEventSummary?.masterFile" fxLayoutGap="5px">
          <span class="text-small">master file</span>
          <span class="text-small" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="'master file: ' + recipeEventSummary?.masterFile" [innerHtml]="recipeEventSummary?.masterFile | encodeHtml | highlight: searchTerm"></span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="15px">
        <div *ngIf="recipeEventSummary?.options?.length">
          <div [matTooltip]="'options: ' + (recipeEventSummary?.options | replace:',':' ')">
            <span class="text-small m-r-5">options</span>
            <span class="text-small" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [innerHtml]="(recipeEventSummary?.options | arrayCount:',') | encodeHtml | highlight: searchTerm"></span>
          </div>
        </div>
  
        <div *ngIf="recipeEventSummary?.themes?.length">
          <div [matTooltip]="'themes: ' + (recipeEventSummary?.themes | replace:'~':' ')">
            <span class="text-small m-r-5">themes</span>
            <span class="text-small" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [innerHtml]="(recipeEventSummary?.themes | arrayCount:'~') | encodeHtml | highlight: searchTerm"></span>
          </div>
        </div>
  
        <div *ngIf="recipeEventSummary?.dateAdded">
          <div [matTooltip]="'date requested: ' + (recipeEventSummary.dateAdded | date:'medium')">
            <span class="text-small text-info">{{ recipeEventSummary.dateAdded | date:'medium' }}</span>
          </div>
        </div>
      </div>
  
      <div fxLayout.lt-md="column" fxFlex fxLayoutAlign.lt-md="center end">
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <!-- Status Display -->
          <mat-icon *ngIf="getStatusIconAndClass(recipeEventSummary)?.class" [class]="getStatusIconAndClass(recipeEventSummary).class"
            [matTooltip]="getStatusIconAndClass(recipeEventSummary).description">
            {{ getStatusIconAndClass(recipeEventSummary).icon }}
          </mat-icon>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</a>